export default [
    {
        key: 'institutions',
        label: 'Academic Qualifications',
    },
    {
        key: 'workExperiences',
        label: 'Work Experiences',
    }
]